import styled, { css } from 'styled-components'
import { FC } from 'react'

import SvgIcon from './Icon/SvgIcon'

type Props = {
  className?: string
  horizontal?: boolean
  forceActiveCss?: boolean
  'data-test'?: string
  stretch?: boolean
  stopClickPropagation?: boolean
}

export const MenuIcon: FC<Props> = ({
  className,
  horizontal = false,
  forceActiveCss = false,
  'data-test': dataTest,
  stretch = false,
  stopClickPropagation = false
}) => {
  return (
    <IconWrapper
      $horizontal={!!horizontal}
      $stretch={stretch}
      $forceActiveCss={forceActiveCss}
      data-test={dataTest}
      className={className}
      onClick={e => stopClickPropagation && e.stopPropagation()}
    >
      <SvgIcon name={horizontal ? 'moreHorizontalBold' : 'moreVerticalBold'} />
    </IconWrapper>
  )
}

const activeStateIconCss = css`
  .primary {
    fill: ${props => props.theme.colors.black};
  }
`

const IconWrapper = styled.div<{
  $horizontal: boolean
  $forceActiveCss: boolean
  $stretch: boolean
}>`
  ${props => props.$stretch && `height: 100%; width: 100%;`};

  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  ${SvgIcon} {
    .primary {
      fill: ${props => props.theme.colors.grey};
    }
  }

  &:hover ${SvgIcon} {
    ${activeStateIconCss};
  }

  ${SvgIcon} {
    ${props => props.$forceActiveCss && activeStateIconCss}
  }
`
